



  $(function () {
    const currentPath = window.location.pathname;

    const transparentsHandle = "/trousers-shorts,/tops,/makers,/d1-mens-product,/d2-mens-product,/".split(",");
console.log("transparentsHandle",transparentsHandle);
    const isTransparentPage = transparentsHandle.some(handle => currentPath.includes(handle));

    if (isTransparentPage) {
      $("body").addClass("has-first-section-overlay-header");
    } else if (currentPath.includes("/pages")) {
      $("body .header__wrapper").removeAttr("data-header-transparent");
    }
  });








